<div class="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" *ngIf="isOpen">
    <div class="modal-content bg-white rounded-lg shadow-lg w-4/5 md:w-1/3">
      
      <!-- Fixed Header -->
      <div class="modal-header sticky top-0 bg-white z-10 p-4 flex justify-between items-center border-b">
        <h2 class="font-semibold text-lg lg:text-xl">Filters</h2>
        <!-- <button (click)="closeModal()" class="text-red-600 text-2xl font-extrabold">Apply</button> -->
        <button
        (click)="closeModal()"
        class="bg-[#7B68EE] py-1 px-2 m-2 text-white font-medium rounded-md"
      >
      Apply
      </button>
      </div>
      
      <!-- Scrollable Modal Body -->
      <div class="modal-body max-h-[60vh] overflow-y-auto p-2">
        <ng-content></ng-content>
      </div>
  
    </div>
  </div>
  